import { get } from 'lodash';
import { getIsForumHot } from './forum-data-selectors';
import { EXPERIMENT_CAPTCHA } from '../constants/experiments';
import { isExperimentEnabled } from './experiments-selectors';

export const getCaptchaSvg = state => get(state.captcha, 'svg', null);
export const getCaptchaId = state => get(state.captcha, 'id', null);
export const getCaptchaAnswer = state => get(state.captcha, 'answer', null);
export const getIsCaptchaAnswerCorrect = state => get(state.captcha, 'isCorrect', false);

export const shouldShowCaptcha = state =>
  isExperimentEnabled(state, EXPERIMENT_CAPTCHA) &&
  getIsForumHot(state) &&
  !getIsCaptchaAnswerCorrect(state);
